<mat-dialog-content data-test="ConfirmDeleteMessage">{{
  'UI.ConfirmationDialog.Delete' | translate : { name: entityName$ | async }
}}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" data-test="ConfirmDeleteCancelButton" [mat-dialog-close]="false">
    {{ 'UI.Common.Action.Cancel' | translate }}
  </button>
  <button mat-flat-button color="primary" data-test="ConfirmDeleteOkButton" [mat-dialog-close]="true">
    {{ 'UI.Common.Action.Delete' | translate }}
  </button>
</mat-dialog-actions>
